module.exports = __webpack_public_path__ + "img/cyan_eight_pointed_star_happy.8ef841b1.png";